module.exports = __webpack_public_path__ + "media/2.f0a5096c.wav";